import { Moment } from "moment";
import { ActionType } from "typesafe-actions";

import { TripClass } from "../common_types";

import * as actions from "./actions";

export type DebugAction = ActionType<typeof actions>;

export enum DebugActionTypes {
  UNWRAP_LINK_REQUEST = "@Debug/UNWRAP_LINK_REQUEST",

  START_SEARCH_REQUEST = "@Debug/START_SEARCH_REQUEST",
  START_SEARCH_SUCCESS = "@Debug/START_SEARCH_SUCCESS",
  START_SEARCH_ERROR = "@Debug/START_SEARCH_ERROR",

  FETCH_DEBUG_SEARCH_RESULTS_REQUEST = "@Debug/FETCH_DEBUG_SEARCH_RESULTS_REQUEST",
  FETCH_DEBUG_SEARCH_RESULTS_SUCCESS = "@Debug/FETCH_DEBUG_SEARCH_RESULTS_SUCCESS",
  FETCH_DEBUG_SEARCH_RESULTS_ERROR = "@Debug/FETCH_DEBUG_SEARCH_RESULTS_ERROR",

  REMOVE_SEARCH_RESULTS = "@Debug/REMOVE_SEARCH_RESULTS",
}

export interface DebugState {
  results?: object[];
  searchDebug?: object;

  debugFile?: string;
  resultsFile?: string;
  searchDebugFile?: string;

  isLoading: { startSearch: boolean; results: boolean };
  errors: { search?: DebugSearchFormError };
}

export interface StartSearchPayload {
  origin: string;
  destination: string;
  departureDate: Moment;
  returnDate?: Moment;

  adults: number;
  children: number;
  infants: number;

  tripClass: TripClass;
  locale?: string;
  currency?: string;
  market?: string;
}

export interface UnwrapLinkPayload {
  url: string;
  onUnwrapSearch: (search?: StartSearchPayload) => void;
}

export interface DebugSearchFormError {
  origin?: string[];
  destination?: string[];
  departureDate?: string[];
  returnDate?: string[];

  adults?: string[];
  children?: string[];
  infants?: string[];

  tripClass?: string[];
  locale?: string[];
  currency?: string[];
  market?: string[];
}

export interface DebugSearchResult {
  results: object[];
  searchDebug?: object;
  debugFile?: string;
  resultsFile?: string;
  searchDebugFile?: string;
}
